import React from 'react';
import {
    CarouselProvider,
    Slider,
    Slide,
    ButtonBack,
    ButtonNext,
    Image,
    DotGroup
} from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';
import { FaChevronRight, FaChevronLeft } from 'react-icons/fa';
import '../Home.css';
import './Carousel.css';

class Carousel extends React.Component {
    render() {
        return (
            <CarouselProvider
                naturalSlideWidth={4}
                naturalSlideHeight={3}
                totalSlides={3}
                isPlaying={true}
                infinite={true}
            >
                <div className={'carousel_content'}>
                    <Slider>
                        <Slide index={0}>
                            <Image hasMasterSpinner={false} src={'/gallery/Bookcases/20200624_220509_1.jpg'}/>
                        </Slide>
                        <Slide index={1}>
                            <Image hasMasterSpinner={false} src={'/gallery/Radiator Covers/1/20200624_221743_1.jpg'}/>
                        </Slide>
                        <Slide index={2}>
                            <Image hasMasterSpinner={false} src={'/gallery/Garden Rooms/1/20200622_224714_1.jpg'}/>
                        </Slide>
                    </Slider>
                    <ButtonBack className={'carousel_back'}><FaChevronLeft size={25}/></ButtonBack>
                    <ButtonNext className={'carousel_next'}><FaChevronRight size={25}/></ButtonNext>
                </div>
                <DotGroup/>
            </CarouselProvider>
        );
    }
}

export default Carousel;